import type { RecurrenceFrequency } from '@project/event-format';

/** Hosts supply their own catalog; standalone consumers retain English defaults. */
export interface WeekPreviewMessages {
  readonly region: string;
  readonly heading: string;
  readonly previous: string;
  readonly next: string;
  readonly today: string;
  readonly note: string;
  readonly scroll: string;
  readonly allDay: string;
  readonly draft: string;
  readonly untitled: string;
  readonly localTime: string;
  readonly empty: string;
  readonly recurrence: Readonly<Record<RecurrenceFrequency, string>>;
}

export const EN_PREVIEW: WeekPreviewMessages = {
  region: 'Weekly calendar preview',
  heading: 'Week preview',
  previous: 'Previous week',
  next: 'Next week',
  today: 'Today',
  note: 'Times are shown as entered, in each event’s time zone. Repeating events show their first occurrence. Select an event to edit it.',
  scroll: 'Scrollable week calendar',
  allDay: 'All day',
  draft: 'Draft',
  untitled: 'Untitled event',
  localTime: 'Local time',
  empty: 'Create an event or import a schedule to see it here.',
  recurrence: {
    daily: 'Repeats daily',
    weekly: 'Repeats weekly',
    monthly: 'Repeats monthly',
    yearly: 'Repeats yearly',
  },
};
